"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var APipe = (function () {
    function APipe() {
    }
    APipe.prototype.transform = function (value, args) {
        if (args === void 0) { args = []; }
        if (value && value.replace) {
            return value.replace(/(http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&#=]*)?)/g, "<a href=\"$1\" target=\"_blank\">$1</a>");
        }
        else {
            return value;
        }
    };
    return APipe;
}());
APipe = __decorate([
    core_1.Pipe({
        name: 'trtA'
    })
], APipe);
exports.APipe = APipe;
